import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import router from './routes/index';
import './styles/global.css';
import './styles/components.css';
import './styles/bottom-nav.css';
import './styles/features/auth.css';
import './styles/features/cart.css';
import './styles/features/checkout.css';

/**
 * QueryClient — configurație optimizată pentru mobile.
 * staleTime 5min reduce re-fetch-urile inutile pe conexiuni lente.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

// IMPORTANT: Konsta <App> wrapper este definit DOAR în App.tsx (cu safeAreas).
// NU duplica <App> wrapper aici — cauzează double Konsta context și safe-areas duble.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
